// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d27ddd35","455":"e9cdfd2f"}[chunkId] + ".chunk.js";
};